import React, { useState } from "react";
import { BarChart3, Activity } from "lucide-react";
import "./app.css";
import Loading from "./loading";
import ClickReport from "./clickReport";

const Reports = (props) => {
  const [loading, setLoading] = useState(false);
  const [activeReport, setActiveReport] = useState(null);

  const REPORTS = [
    {
      id: "clicks",
      label: "Raport pracy",
      icon: Activity,
      component: ClickReport,
    },
  ];

  if (loading) return <Loading />;

  const ActiveComponent = REPORTS.find((r) => r.id === activeReport)?.component;

  return (
    <div className="rep-wrapper">
      {/* ── Header ── */}
      <div className="rp-header">
        <div className="rp-header-icon">
          <BarChart3 size={22} />
        </div>
        <div>
          <h2 className="rp-title">Raporty</h2>
          <p className="rp-subtitle">Wybierz raport do wygenerowania</p>
        </div>
      </div>

      {/* ── Report buttons ── */}
      <div className="rep-grid">
        {REPORTS.map((r) => {
          const Icon = r.icon;
          const isActive = activeReport === r.id;
          return (
            <button
              key={r.id}
              className={`rep-card ${isActive ? "rep-card--active" : ""}`}
              onClick={() => setActiveReport(isActive ? null : r.id)}
            >
              <div
                className={`rep-card-icon ${
                  isActive ? "rep-card-icon--active" : ""
                }`}
              >
                <Icon size={22} />
              </div>
              <span className="rep-card-label">{r.label}</span>
            </button>
          );
        })}
      </div>

      {/* ── Active report ── */}
      {ActiveComponent && (
        <div className="rep-content">
          <ActiveComponent user={props.user} />
        </div>
      )}
    </div>
  );
};

export default Reports;
